import EventBus from "../../eventBus";

const state = {
  loading: false,
  isMobile: null,
  webp: null,
  isWebpSupported: false,
  sticky: null,
  origin: "https://dayz.com/"
};

const getters = {
  isWebpSupported: state => state.webp
};

const actions = {
  setLoading({ commit }, result) {
    if (!result) {
      EventBus.$emit("dataLoaded");
    }
    commit("setLoading", result);
  }
};

const mutations = {
  isMobile(state, val) {
    state.isMobile = val;
  },
  webp(state, val) {
    state.webp = val;
  },
  sticky(state, val) {
    state.sticky = val;
  },
  setLoading(state, val) {
    if (state.loading !== val) {
      state.loading = val;
    }
  },
  setOrigin(state, url) {
    if (state.origin !== url) {
      state.origin = url;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
